function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  x2: "100%",
  y2: "50%",
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F05E75",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D62838",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "28.473%",
  y1: "49.947%",
  x2: "71.629%",
  y2: "49.947%",
  id: "e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9CA64",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2B13A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "28.608%",
  y1: "49.975%",
  x2: "71.721%",
  y2: "49.975%",
  id: "h"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9CA64",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2B13A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "28.401%",
  y1: "50.006%",
  x2: "71.298%",
  y2: "50.006%",
  id: "k"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9CA64",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2B13A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  x2: "100%",
  y2: "50%",
  id: "n"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9CA64",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2B13A",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  x2: "100%",
  y2: "50%",
  id: "q"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0A72BA",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26A7DF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-11891.596%",
  y1: "50%",
  x2: "-11791.596%",
  y2: "50%",
  id: "t"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#23B182",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5BBF95",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 1.342c0 .741.59 1.342 1.319 1.342s1.32-.6 1.32-1.342A1.33 1.33 0 0 0 1.318 0C.591 0 0 .6 0 1.342",
  id: "a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.028.067V.08A.4.4 0 0 0 .071.02C.07.02.028.067.028.067",
  id: "d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.072.08V.068S.032.02.029.02a.43.43 0 0 0 .043.06",
  id: "g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.072.08V.07S.032.019.029.019a.456.456 0 0 0 .043.062",
  id: "j"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.327.587a2.753 2.753 0 0 0-.477.487 1.61 1.61 0 0 1-.03.02l.013.002c.216.024.426.086.62.183a3.22 3.22 0 0 0-.167.165l-.009.01c-.09.097-.174.2-.252.308l-.012.017c-.035.05-.069.102-.101.154l-.009.014a2.98 2.98 0 0 0-.098.173 3.065 3.065 0 0 0-.23.57v.001l-.013.045a4.287 4.287 0 0 0-.038.154l-.01.038a3.283 3.283 0 0 0-.033.19l-.005.041a2.894 2.894 0 0 0-.016.158l-.004.054a2.898 2.898 0 0 0-.003.347c0 .017.002.033.003.05v.003l.006.094.007.059.01.086.01.062.014.081.013.063.017.078.016.062c.006.027.014.052.021.078l.017.06c.013.043.027.084.042.126l.028.073.022.056.032.075.023.05c.011.027.024.052.036.078l.023.045.041.078.023.039.046.08.017.027c.033.053.068.105.104.156l.014.018c.029.04.058.08.09.118A3.006 3.006 0 0 0 4.48 6.656c1.51-.002 2.735 1.242 2.737 2.778.002 1.535-1.22 2.782-2.73 2.784-1.509.002-2.734-1.241-2.736-2.777 0-.564.167-1.115.481-1.58l-.001.002L.864 6.748c-1.46 2.03-1.026 4.88.97 6.367.768.571 1.695.88 2.647.879 2.474 0 4.48-2.04 4.481-4.558 0-1.591-.814-3.067-2.15-3.895a5.779 5.779 0 0 0-1.267-.467 4.653 4.653 0 0 0-1.064-.139 1.331 1.331 0 0 1-.797-.269l-.013-.01a1.397 1.397 0 0 1-.07-.057 1.348 1.348 0 0 1-.189-.206l-.026-.037a.864.864 0 0 1-.065-.103c-.009-.016-.02-.034-.028-.051a1.207 1.207 0 0 1-.033-.068l-.017-.038a1.345 1.345 0 0 1-.04-.11l-.01-.04a1.3 1.3 0 0 1-.021-.08l-.009-.044a1.31 1.31 0 0 1-.013-.085l-.004-.04a1.38 1.38 0 0 1-.007-.127v-.015c0-.658.461-1.223 1.097-1.345l.08-.014a1.106 1.106 0 0 1 1.245-.958c.545.077.951.552.95 1.113v.026c.016-.085.025-.172.027-.259l.001-.04-.001-.042a1.567 1.567 0 0 0-.112-.544 1.368 1.368 0 0 0-.268-.423A2.708 2.708 0 0 0 4.004 0c-.587 0-1.178.192-1.677.587",
  id: "m"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.738 0c-.001.066-.174 1.298-.876 2.531-.326.574-1.346 1.631-1.346 1.631l-.005.004v-.001l-.001.001C-1.542 9.488-.587 17.144 4.643 21.267c.222.175.449.341.682.5l.009.007.012.007.04.02a1.534 1.534 0 0 1 1.324 1.185.48.48 0 0 1 .005.014c.168-.174.307-.614.363-.806.041-.199.052-.403.032-.605a1.9 1.9 0 0 0-.713-1.226l-.02-.016a2.19 2.19 0 0 0-.063-.05l-.005-.004C1.608 17.104.337 10.642 3.47 5.858c.13-.197.266-.39.409-.579 0 0 1.21-.951 1.331-1.808 0 0 .923 1.623.224 3.074-2.76 3.68-2.067 8.94 1.549 11.749.074.058.15.114.226.17l-.002.002c.9.73 1.746 1.525 2.535 2.378.298.021.583.134.816.325.308.25.511.61.572 1.006l.002.004.007-.017c.067-.104.497-.838.055-2.057l-.003-.01c-.369-.925-1.456-1.912-2.217-2.521a13.625 13.625 0 0 0-.793-.593c-2.727-2.009-3.492-5.805-1.763-8.744.112-.19 2.02-2.776-.25-6.218A163.19 163.19 0 0 1 4.738 0z",
  id: "p"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.654 0c-.086.127-.403.58-1.43 2.02-2.271 3.441-.362 6.027-.25 6.217 1.729 2.94.963 6.735-1.763 8.744 0 0-.339.229-.794.593-.761.609-1.848 1.596-2.216 2.521l-.004.01c-.442 1.219-.012 1.953.056 2.057l.006.017.003-.004a1.61 1.61 0 0 1 .571-1.007c.234-.19.519-.303.817-.323a24.444 24.444 0 0 1 2.534-2.379l-.001-.003c.076-.055.151-.111.226-.17 3.616-2.808 4.31-8.068 1.549-11.748-.7-1.452.223-3.075.223-3.075.12.857 1.332 1.809 1.332 1.809.142.188.278.38.408.578 3.134 4.784 1.863 11.247-2.838 14.436l-.005.004a2.1 2.1 0 0 0-.064.05l-.019.016a1.9 1.9 0 0 0-.714 1.226c-.02.202-.009.406.033.605.055.192.195.632.362.806l.005-.014c.15-.641.681-1.116 1.325-1.184a2.31 2.31 0 0 0 .04-.021l.012-.007.009-.007c.233-.159.46-.325.681-.5 5.23-4.123 6.185-11.78 2.134-17.1l-.001-.002-.006-.003s-1.02-1.057-1.346-1.63C6.827 1.297 6.655.065 6.654 0z",
  id: "s"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.68 10.787)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 1.342c0 .741.59 1.342 1.319 1.342s1.32-.6 1.32-1.342A1.33 1.33 0 0 0 1.318 0C.591 0 0 .6 0 1.342",
  fill: "url(#b)",
  mask: "url(#c)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20.701 3.287)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.028.067V.08A.4.4 0 0 0 .071.02C.07.02.028.067.028.067",
  fill: "url(#e)",
  mask: "url(#f)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.146 8.067)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "i",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.072.08V.068S.032.02.029.02a.43.43 0 0 0 .043.06",
  fill: "url(#h)",
  mask: "url(#i)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.28 3.29)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#j"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.072.08V.07S.032.019.029.019a.456.456 0 0 0 .043.062",
  fill: "url(#k)",
  mask: "url(#l)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#F0637C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.73 3.356v.013c.097-.13 0-.013 0-.013M9.217 8.149v-.013s-.095-.119 0 .013M3.351 3.36s-.097-.119 0 .011V3.36z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.518 2.696)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "o",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#m"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.327.587a2.753 2.753 0 0 0-.477.487 1.61 1.61 0 0 1-.03.02l.013.002c.216.024.426.086.62.183a3.22 3.22 0 0 0-.167.165l-.009.01c-.09.097-.174.2-.252.308l-.012.017c-.035.05-.069.102-.101.154l-.009.014a2.98 2.98 0 0 0-.098.173 3.065 3.065 0 0 0-.23.57v.001l-.013.045a4.287 4.287 0 0 0-.038.154l-.01.038a3.283 3.283 0 0 0-.033.19l-.005.041a2.894 2.894 0 0 0-.016.158l-.004.054a2.898 2.898 0 0 0-.003.347c0 .017.002.033.003.05v.003l.006.094.007.059.01.086.01.062.014.081.013.063.017.078.016.062c.006.027.014.052.021.078l.017.06c.013.043.027.084.042.126l.028.073.022.056.032.075.023.05c.011.027.024.052.036.078l.023.045.041.078.023.039.046.08.017.027c.033.053.068.105.104.156l.014.018c.029.04.058.08.09.118A3.006 3.006 0 0 0 4.48 6.656c1.51-.002 2.735 1.242 2.737 2.778.002 1.535-1.22 2.782-2.73 2.784-1.509.002-2.734-1.241-2.736-2.777 0-.564.167-1.115.481-1.58l-.001.002L.864 6.748c-1.46 2.03-1.026 4.88.97 6.367.768.571 1.695.88 2.647.879 2.474 0 4.48-2.04 4.481-4.558 0-1.591-.814-3.067-2.15-3.895a5.779 5.779 0 0 0-1.267-.467 4.653 4.653 0 0 0-1.064-.139 1.331 1.331 0 0 1-.797-.269l-.013-.01a1.397 1.397 0 0 1-.07-.057 1.348 1.348 0 0 1-.189-.206l-.026-.037a.864.864 0 0 1-.065-.103c-.009-.016-.02-.034-.028-.051a1.207 1.207 0 0 1-.033-.068l-.017-.038a1.345 1.345 0 0 1-.04-.11l-.01-.04a1.3 1.3 0 0 1-.021-.08l-.009-.044a1.31 1.31 0 0 1-.013-.085l-.004-.04a1.38 1.38 0 0 1-.007-.127v-.015c0-.658.461-1.223 1.097-1.345l.08-.014a1.106 1.106 0 0 1 1.245-.958c.545.077.951.552.95 1.113v.026c.016-.085.025-.172.027-.259l.001-.04-.001-.042a1.567 1.567 0 0 0-.112-.544 1.368 1.368 0 0 0-.268-.423A2.708 2.708 0 0 0 4.004 0c-.587 0-1.178.192-1.677.587",
  fill: "url(#n)",
  mask: "url(#o)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "r",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#p"
})), /*#__PURE__*/React.createElement("path", {
  d: "M4.738 0c-.001.066-.174 1.298-.876 2.531-.326.574-1.346 1.631-1.346 1.631l-.005.004v-.001l-.001.001C-1.542 9.488-.587 17.144 4.643 21.267c.222.175.449.341.682.5l.009.007.012.007.04.02a1.534 1.534 0 0 1 1.324 1.185.48.48 0 0 1 .005.014c.168-.174.307-.614.363-.806.041-.199.052-.403.032-.605a1.9 1.9 0 0 0-.713-1.226l-.02-.016a2.19 2.19 0 0 0-.063-.05l-.005-.004C1.608 17.104.337 10.642 3.47 5.858c.13-.197.266-.39.409-.579 0 0 1.21-.951 1.331-1.808 0 0 .923 1.623.224 3.074-2.76 3.68-2.067 8.94 1.549 11.749.074.058.15.114.226.17l-.002.002c.9.73 1.746 1.525 2.535 2.378.298.021.583.134.816.325.308.25.511.61.572 1.006l.002.004.007-.017c.067-.104.497-.838.055-2.057l-.003-.01c-.369-.925-1.456-1.912-2.217-2.521a13.625 13.625 0 0 0-.793-.593c-2.727-2.009-3.492-5.805-1.763-8.744.112-.19 2.02-2.776-.25-6.218A163.19 163.19 0 0 1 4.738 0z",
  fill: "url(#q)",
  mask: "url(#r)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.608 .5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "u",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s"
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.654 0c-.086.127-.403.58-1.43 2.02-2.271 3.441-.362 6.027-.25 6.217 1.729 2.94.963 6.735-1.763 8.744 0 0-.339.229-.794.593-.761.609-1.848 1.596-2.216 2.521l-.004.01c-.442 1.219-.012 1.953.056 2.057l.006.017.003-.004a1.61 1.61 0 0 1 .571-1.007c.234-.19.519-.303.817-.323a24.444 24.444 0 0 1 2.534-2.379l-.001-.003c.076-.055.151-.111.226-.17 3.616-2.808 4.31-8.068 1.549-11.748-.7-1.452.223-3.075.223-3.075.12.857 1.332 1.809 1.332 1.809.142.188.278.38.408.578 3.134 4.784 1.863 11.247-2.838 14.436l-.005.004a2.1 2.1 0 0 0-.064.05l-.019.016a1.9 1.9 0 0 0-.714 1.226c-.02.202-.009.406.033.605.055.192.195.632.362.806l.005-.014c.15-.641.681-1.116 1.325-1.184a2.31 2.31 0 0 0 .04-.021l.012-.007.009-.007c.233-.159.46-.325.681-.5 5.23-4.123 6.185-11.78 2.134-17.1l-.001-.002-.006-.003s-1.02-1.057-1.346-1.63C6.827 1.297 6.655.065 6.654 0z",
  fill: "url(#t)",
  mask: "url(#u)"
})));

function SvgIco24TokenFinix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco24TokenFinix);
export default __webpack_public_path__ + "static/media/ico_24_token_finix.48142465.svg";
export { ForwardRef as ReactComponent };